import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { DefaultButton } from '..';
import ChatProfile from '../ChatProfile/ChatProfile';
import Icon from '../Icon/Icon';
import * as S from './PasswordModal.styled';

interface PasswordModalProps {
  onClick: (password: string) => void;
  password: string;
  setPassword: (password: string) => void;
  error: string;
  setError: (error: string) => void;
  images: string[];
  title: string;
}

export default function PasswordModal({
  onClick,
  password,
  setPassword,
  error,
  setError,
  images,
  title,
}: PasswordModalProps) {
  const navigate = useNavigate();
  const passwordInputRef = useRef<HTMLInputElement>(null);

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
    if (error) {
      setError('');
    }
  };

  useEffect(() => {
    if (error && passwordInputRef.current) {
      setPassword('');
      passwordInputRef.current.focus();
    }
  }, [error, setPassword]);
  return (
    <>
      <>
        <S.Container className='PasswordModal'>
          <S.ContentWrapper>
            <S.TitleBox>
              <ChatProfile characters={images} />
              <S.Title>{title}</S.Title>
            </S.TitleBox>
            <S.DescBox>
              <S.Desc>Enter group chat password</S.Desc>
              <S.Password>
                <input
                  ref={passwordInputRef}
                  type='password'
                  placeholder='Password'
                  value={password}
                  onChange={handleOnChange}
                />
              </S.Password>
              {error && <S.ErrorMsg>{error}</S.ErrorMsg>}
            </S.DescBox>
          </S.ContentWrapper>
          <S.ButtonWrapper type={'single'}>
            <S.SingleButtonBox>
              <DefaultButton
                disabled={password.trim().length === 0 || error !== ''}
                onClick={() => onClick(password)}
              >
                Join
              </DefaultButton>
            </S.SingleButtonBox>
          </S.ButtonWrapper>
          <S.CloseButton onClick={() => navigate(-1)}>
            <Icon color='hierarchy1' size={28} iconName='Close' />
          </S.CloseButton>
        </S.Container>
        <S.Background className='background' />
      </>
    </>
  );
}
